import axios from "axios";
import { API_URL } from "../constants/api";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30s timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor → attach token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle errors globally
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Don't toast on intentional cancellations (AbortController) — let the
    // caller (e.g. an effect cleanup) handle it silently.
    if (axios.isCancel?.(error) || error?.name === "CanceledError" || error?.name === "AbortError") {
      return Promise.reject(error);
    }
    // NOTE: error MESSAGES are owned by the caller layer (apiWrapper converts a
    // rejected request into a { status:'fail', message } object and each caller
    // toasts response.message). So this interceptor must NOT toast, or every
    // error would show twice. It only keeps the 401 side-effect (clear session
    // + redirect); the "session expired" wording is surfaced by the caller.
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
